export default "__VITE_ASSET__DbYkO18$__"